import { motion } from 'motion/react';
import { FC, ReactNode } from 'react';
import { CrossBigIcon } from 'shared/icons';
import { mergeClasses } from 'shared/utils/mergeClasses';
import { IconButton } from '../IconButton/IconButton';

interface ModalBackgroundProps {
  children: ReactNode;
  name: string;
  title?: string;
  className?: string;
  wrapperClassName?: string;
  showCloseButton?: boolean;
  onClose?: () => void;
}

export const ModalContent: FC<ModalBackgroundProps> = ({
  children,
  className = '',
  wrapperClassName = '',
  name,
  title,
  showCloseButton = false,
  onClose,
}) => {
  return (
    <div
      className={mergeClasses(
        'flex-center fixed left-0 top-0 z-50 h-screen w-screen bg-black/65 lg:p-4',
        wrapperClassName,
      )}
    >
      <motion.div
        initial={{ y: 16 }}
        animate={{ y: 0 }}
        exit={{ y: 16 }}
        transition={{ duration: 0.2, ease: 'easeOut' }}
        className={mergeClasses(
          'relative w-screen rounded-2xl bg-white px-4 py-6 md:px-12',
          className,
        )}
        id={name}
      >
        {showCloseButton && onClose && (
          <IconButton
            name={`${name}CloseButton`}
            icon={CrossBigIcon}
            onClick={onClose}
            className="absolute right-2.5 top-4.5 md:right-2 md:top-2"
            variant="primary"
            size="lg"
          />
        )}
        {title && (
          <h3
            className={mergeClasses(
              'mb-6 text-center text-xl font-bold',
              showCloseButton ? 'px-6' : '',
            )}
          >
            {title}
          </h3>
        )}
        {children}
      </motion.div>
    </div>
  );
};
